import { render, staticRenderFns } from "./error-handler.vue?vue&type=template&id=6646448c&"
import script from "./error-handler.vue?vue&type=script&lang=js&"
export * from "./error-handler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports